import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { cn } from '@/lib/utils';

import { useSrfUserEntry } from '../model';
import type { SrfUserEntrySection } from '../lib';

interface SrfUserEntryNoteProps {
  section: SrfUserEntrySection;
}

export function SrfUserEntryNote({ section }: SrfUserEntryNoteProps) {
  const { t } = useTranslation();
  const rows = useSrfUserEntry()?.[section];

  if (!rows?.length) return null;

  return (
    <Alert variant="warning" role="note">
      <AlertTitle>{t('newcmr.srf.user.entry.label')}</AlertTitle>
      <AlertDescription className="@container">
        <dl className="grid w-full gap-x-6 gap-y-1.5 @lg:grid-cols-2">
          {rows.map(({ labelKey, value }) => (
            <div key={labelKey} className="min-w-0">
              <dt className={cn(value && 'text-xs text-muted-foreground')}>{t(labelKey)}</dt>
              {value && <dd className="font-medium break-words">{value}</dd>}
            </div>
          ))}
        </dl>
      </AlertDescription>
    </Alert>
  );
}
